@let isMoveMode = dragAndDropModeService.isMoveMode$ | async;
@let draggingShift = dragAndDropModeService.draggingShiftV2$ | async;
@let draggingAbsence = dragAndDropModeService.draggingAbsence$ | async;
@let defaultRowHeight = defaultRowHeight$ | async;
@if (
  {
    frameLength: frameLength$ | async,
    publicHolidaysRegion: publicHolidaysRegion$ | async,
    rowHoverIndex: timelineInteractionService.hoveredRowIndex$ | async,
    resourcesColumnWidthPx: resourcesColumnWidthPx$ | async,
  };
  as timelineData
) {
  <wilson-dates-demarcator-lines
    [leftMarginPx]="timelineData.resourcesColumnWidthPx || 0"
    [panelWidth]="timelineData.frameLength || 0"
    [interval]="timeframe$ | async"
    [holidayRegions]="publicHolidaysRegion$ | async"
    [visibleDaysRange]="visibleDaysRange$ | async"
  ></wilson-dates-demarcator-lines>
  @if (isMoveMode && draggingShift) {
    <wilson-move-shift-drop-zone-cell-view></wilson-move-shift-drop-zone-cell-view>
  }
  @if (isMoveMode && draggingAbsence) {
    <wilson-move-absence-drop-zone-cell-view></wilson-move-absence-drop-zone-cell-view>
  }
  <div [style.height.px]="rowHeightWithBorder * (fullUserLength || 0)">
    @let trimmedUserList = (trimmedUserList$ | async) || [];
    @let visibleUserIdsSet =
      assignedRegionVisibilityStateService.visibleUserIdsSet$ | async;
    @for (
      user of trimmedUserList;
      track trackById(i, user);
      let i = $index;
      let c = $count
    ) {
      @let assignmentStacks = user | toUserAssignmentStacks | async;
      @let isHovered = i === timelineData.rowHoverIndex;
      @if (assignmentStacks) {
        @let isUserVisible = visibleUserIdsSet?.has(user.id!);
        @if (isUserVisible) {
          <div class="d-flex">
            <div
              id="left-container"
              class="sticky"
              [class.hover]="isHovered"
              [style.border-bottom-width.px]="ROW_BORDER_BOTTOM_PX"
            >
              <div
                id="left-block"
                [style.width.px]="timelineData.resourcesColumnWidthPx"
              >
                <wilson-user-timelines-info-card
                  [index]="i"
                  [user]="user"
                ></wilson-user-timelines-info-card>
              </div>
            </div>
            <div
              id="right-container"
              class="timeline-container"
              [style.width.px]="timelineData.frameLength"
            >
              <div id="right-block" class="timeline-block">
                <div class="items-container">
                  <div
                    class="item"
                    [class.hover]="isHovered"
                    (mouseenter)="
                      timelineInteractionService.setHoveredRowIndex(i)
                    "
                  >
                    <wilson-timeline-cell-view-user-row-assignments
                      [user]="user"
                      [assignmentStacksData]="assignmentStacks"
                      [defaultRowHeight]="defaultRowHeight"
                      [isLastUserRow]="i === (trimmedUserList?.length ?? 0) - 3"
                      [isTooltipVisible]="
                        timelineShiftDragAndDropDirectiveHelperService.isTooltipVisible$
                          | async
                      "
                    ></wilson-timeline-cell-view-user-row-assignments>
                  </div>
                </div>
                @defer {
                  @if (isUserVisible && !isHovered) {
                    <wilson-weekend-holiday-highlighter
                      [data]="weekendHolidayRenderData"
                    ></wilson-weekend-holiday-highlighter>
                  }
                }
              </div>
            </div>
          </div>
        } @else {
          <div [style.height.px]="rowHeightWithBorder"></div>
        }
      }
    }
  </div>
}
